export enum ApprovalType {
  AGREE = 'agree',
  DISAGREE = 'disagree',
}
